module.exports = __webpack_public_path__ + "509f258cf65bbfb3d6980dafb5e2d378.svg";